import(/* webpackMode: "eager", webpackExports: ["LobbyHeaderMeta"] */ "/vercel/path0/contexts/LobbyHeaderMetaContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.13_@opentelemetry+api@1.9.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.98.0/node_modules/next/dist/client/app-dir/link.js");
